import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { ValidationProvider } from 'vee-validate';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

@Component({
  name: 'bpc-field-wrapper',
  components: {
    ValidationProvider,
    'font-awesome-icon': FontAwesomeIcon,
  },
})
export default class FieldWrapper extends Vue {
  @Prop(String) readonly id: string;

  @Prop(String) readonly name: string;

  @Prop({
    type: Boolean,
    default: false,
  })
  readonly disabled: boolean;

  @Prop({
    type: Boolean,
    default: null,
  })
  readonly state: boolean;

  @Prop({
    type: [Object, Array],
    default() {
      return {};
    },
  })
  readonly wrapperAttributes: object | string[];

  @Prop(Boolean) readonly showLabel: boolean;

  @Prop(String) readonly label: string;

  @Prop([String, Object, Array]) readonly labelClass: string | object | string[];

  @Prop({
    type: [Object, Array],
    default() {
      return {};
    },
  })
  readonly labelAttributes: object | string[];

  @Prop(Boolean) readonly required: boolean;

  @Prop({ type: Boolean, default: true }) readonly veeValidation: boolean;

  @Prop({ type: Boolean, default: true }) readonly showError: boolean;

  @Prop([String, Object, Array]) readonly errorClass: string | object | string[];

  @Prop([Object, Array]) readonly errorAttributes: object | string[];

  @Prop(String) readonly error: string;

  @Prop([String, Array]) readonly rules: string | string[] | null;

  @Prop({
    type: Boolean,
    default: true,
  })
  readonly showHelp: boolean;
  @Prop({ type: [String], default: 'tooltip' }) readonly helpMode:
    | 'tooltip'
    | 'displayed_below'
    | 'hidden';

  @Prop([String, Object, Array]) helpClass: string | object | string[];

  @Prop([Object, Array]) readonly helpAttributes: object | string[];

  @Prop(String) readonly help: string;

  @Prop({
    type: Boolean,
    default: true,
  })
  readonly showFeedback: boolean;

  @Prop([String, Object, Array]) readonly feedbackClass: string | object | string[];

  @Prop([Object, Array]) readonly feedbackAttributes: object | string[];

  @Prop(String) readonly feedback: string;

  allowedRules: string[] = [
    'required',
    'required_if',
    'required_if_show_mandatory',
    'required_in_settings',
  ]; // TODO: Add all allowed rules shared between backend and frontend

  get filteredRules() {
    const rulesArray =
      typeof this.rules === 'string' ? this.rules.split('|').map(item => item.trim()) : this.rules;

    if (Array.isArray(rulesArray)) {
      return rulesArray
        .filter((rule: string) => {
          const ruleName = rule.split(':')[0];
          return this.allowedRules.includes(ruleName);
        })
        .join('|');
    }
    return null;
  }

  get attributes() {
    const res: Record<string, string | number | boolean> = {};

    Object.keys(this.labelAttributes).forEach((key: string) => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      this.$set(res, `label-${key}`, (this.labelAttributes as any)[key]);
    });

    if (this.showError && this.state === false) {
      this.$set(res, 'state', false);
    }

    if (this.showFeedback && this.state === true) {
      this.$set(res, 'state', true);
    }

    this.$set(res, 'disabled', this.disabled);
    return res;
  }

  get isRequired(): boolean {
    if (this.required) {
      return true;
    }
    if (this.filteredRules) {
      if (
        this.filteredRules.split(':')[0] === 'required_if_show_mandatory' &&
        this.$store.getters['centerSettings/centerSettings'][this.filteredRules.split(':')[1]] ===
          'display_mandatory'
      ) {
        return true;
      } else if (
        this.filteredRules.split(':')[0] === 'required_in_settings' &&
        this.$store.getters['centerSettings/centerSettings'][this.filteredRules.split(':')[1]] ===
          'mandatory'
      ) {
        return true;
      } else {
        return (
          this.filteredRules.split(':')[0] === 'required' ||
          this.filteredRules.split(':')[0] === 'required_if'
        );
      }
    }
    return false;
  }

  get showPopoverHelpWithIcon(): boolean {
    // NOTE $te is a VueI18n method to test if a translation exists
    return this.helpMode === 'tooltip' && this.$te(this.help);
  }

  get showFixedHelpBelowField(): boolean {
    // NOTE $te is a VueI18n method to test if a translation exists
    return this.helpMode === 'displayed_below' && this.$te(this.help);
  }

  /* Lifecycle hooks */
  // created () { }

  // mounted () { }

  // updated () { }

  // destroyed () { }
}
